import { useCallback, useEffect, useState } from 'react';

import { useYearQuarterNavigation } from 'hooks';
import { useRecoilState, useRecoilValue } from 'recoil';
import { v4 as uuidv4 } from 'uuid';

import {
  CapacityBalanceResponse,
  getCapacityBalance
} from 'RestAPIs/roster/formation';

import { scenarioAtom } from '../../atoms';
import { capacityBalanceAtom, updateFlexForecastAtom } from '../atoms';

import { Box } from '@mui/material';

import { LoadingOverlay, SkeletonWithIcon } from 'components/shared';

import { VIEW } from '../const';
import CapacityBalanceGraph from './component/CapacityBalanceGraph';
import CapacityBalanceTable from './component/CapacityBalanceTable';

const FlexForecast = () => {
  const scenario = useRecoilValue(scenarioAtom);
  const { year, quarter, isViewPerWeek } = useYearQuarterNavigation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [, setCapacityBalance] = useRecoilState(capacityBalanceAtom);
  const [updateFlexForecast, setUpdateFlexForecast] = useRecoilState(
    updateFlexForecastAtom
  );

  const reloadCapacityBalance = useCallback(() => {
    if (scenario?.scenarioId) {
      setIsLoading(true);
      getCapacityBalance({
        scenarioId: scenario.scenarioId,
        year,
        aggregateOn: isViewPerWeek ? VIEW.WEEK : VIEW.MONTH,
        quarter: isViewPerWeek ? quarter : null
      })
        .then(({ data }) => {
          setCapacityBalance({
            ...data,
            functionCapacityBalances: data.functionCapacityBalances?.map(
              (functionCapacityBalance) => ({
                ...functionCapacityBalance,
                uuid: uuidv4()
              })
            )
          } as CapacityBalanceResponse);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [scenario, year, isViewPerWeek, quarter]);

  useEffect(() => {
    reloadCapacityBalance();
  }, [scenario, year, isViewPerWeek, quarter]);

  useEffect(() => {
    if (updateFlexForecast) {
      reloadCapacityBalance();
      setUpdateFlexForecast(false);
    }
  }, [updateFlexForecast]);

  return (
    <>
      <LoadingOverlay loading={isLoading} />
      {scenario && (
        <>
          <Box mt={2} mb={4}>
            {isLoading ? (
              <SkeletonWithIcon height={400} />
            ) : (
              <CapacityBalanceGraph />
            )}
          </Box>
          <CapacityBalanceTable />
        </>
      )}
    </>
  );
};

export default FlexForecast;
